<template>
    <div>
        <modal :show="show">
            <div class="modal-header">
                <h5 class="modal-title">Request For Withdrawal</h5>
                <a href="javascript:void(0)" v-on:click="close()" class="close">
                    <em class="icon ni ni-cross"></em>
                </a>
            </div>

            <div class="modal-body" v-if="(isWeekend!='Saturday' && isWeekend!='Sunday') || type!='Add'">
                <div class="row" v-if="isProfileApproved">
                    <div class="form-group col-md-12">
                        <p class="text-danger">Note: Minimum Withdrawal limit is $10.</p>
                        <label>Amount $</label>
                        <input v-model="transfer.amount" v-bind:disabled="type!='Add'" @keyup="updateFee($event.target.value)" type="number" @focus="$event.target.select()" class="form-control" />
                        <p>Fee : ${{transfer.feeAmount}}</p>
                    </div>

                    <div class="form-group col-md-12" v-if="isSendOtp">
                        <input v-model="transfer.otp" type="number" @focus="$event.target.select()" placeholder="Enter OTP Code" class="form-control" />
                    </div>

                    <div class="form-group col-md-12" v-if="approval=='Rejected'">
                        <label>Reason</label>
                        <textarea v-model="transfer.reason" class="form-control"></textarea>
                    </div>

                    <div class="form-group col-md-12" v-if="approval=='Approved'">
                        <label>Bank</label>
                        <bankdropdown v-model="transfer.bankAccountId" />
                    </div>

                    <div class="form-group col-md-12" v-if="type=='Add'">
                        <label class="form-label">Select Account</label>
                        <div class="g-4 align-center flex-wrap" :key="render">
                            <div class="g" v-if="userDetails.paymentOptionIdOne!='' && userDetails.paymentOptionIdOne!=null && userDetails.paymentOptionIdOne!=undefined && userDetails.paymentOptionIdOneActive">
                                <div class="custom-control custom-radio" v-on:click="SelectBank(userDetails, true)">
                                    <input v-model="transfer.bankId" type="radio" class="custom-control-input" :value="userDetails.paymentOptionIdOne" id="paymentOptionIdOne">
                                    <label class="custom-control-label" for="paymentOptionIdOne">{{userDetails.bankAccountNoOne}} <br />{{userDetails.paymentOptionIdOneName}} </label>

                                </div>

                            </div>
                            <div class="g" v-if="userDetails.paymentOptionIdTwo!='' && userDetails.paymentOptionIdTwo!=null && userDetails.paymentOptionIdTwo!=undefined && userDetails.paymentOptionIdTwoActive">
                                <div class="custom-control custom-radio" v-on:click="SelectBank(userDetails, false)">
                                    <input v-model="transfer.bankId" type="radio" class="custom-control-input" :value="userDetails.paymentOptionIdTwo" id="paymentOptionIdTwo">
                                    <label class="custom-control-label" for="paymentOptionIdTwo">{{userDetails.bankAccountNoTwo}} <br />{{userDetails.paymentOptionIdTwoName}}</label>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div class="row" v-else>
                    <div class="form-group col-md-12">
                        <p class="text-danger">Alert: Your profile data not completed.</p>
                    </div>
                </div>
            </div>
            <div class="modal-body" v-else>
                <div class="row">
                    <div class="form-group col-md-12">
                        <p class="text-danger">Saturday and Sunday Withdrawal will not be processed.</p>
                    </div>
                </div>
            </div>

            <div class="modal-footer bg-light" v-if="isProfileApproved && ((isWeekend!='Saturday' && isWeekend!='Sunday') || type!='Add') ">
                <button type="button" v-if="type=='Add' && !isSendOtp" class="btn btn-primary btn-round" v-on:click="SendOtp()" v-bind:disabled="$v.$invalid || ((transfer.amount + transfer.feeAmount) > userDetails.netProfit) || (transfer.amount + transfer.feeAmount)<10">OTP Verification</button>
                <button type="button" v-if="type=='Add' && isSendOtp" class="btn btn-primary btn-round" v-on:click="SaveFund()" v-bind:disabled="$v.$invalid || ((transfer.amount + transfer.feeAmount) > userDetails.netProfit) || (transfer.amount + transfer.feeAmount)<10">Submit</button>


                <button type="button" v-if="approval=='Approved'" class="btn btn-primary btn-round" v-on:click="SaveEdit()" v-bind:disabled="$v.$invalid || transfer.bankAccountId==''  || transfer.bankAccountId==null  || transfer.bankAccountId==undefined">Approved</button>
                <button type="button" v-if="approval=='Rejected'" class="btn btn-warning btn-round" v-on:click="SaveEdit()">Rejected</button>
                <button type="button" class="btn btn-danger btn-round" v-on:click="close()">Cancel</button>
            </div>
        </modal>

        <loading :name="loading" :active.sync="loading"
                 :can-cancel="false"
                 :is-full-page="true"></loading>
    </div>
</template>
<script>
    import { required } from "vuelidate/lib/validators";
    import Loading from 'vue-loading-overlay';
    import "vue-loading-overlay/dist/vue-loading.css";
    import moment from 'moment'

    export default {
        components: {
            Loading
        },
        props: ['userDetail', 'show', 'type', 'approval'],
        data: function () {
            return {
                transfer: {
                    id: '00000000-0000-0000-0000-000000000000',
                    amount: 0,
                    feeAmount: 0,
                    bankId: '',
                    bankAccountNo: '',
                    bankAccountId: '',
                    otp: '',
                    bankName: '',
                    reason: '',
                    approval: 'Processing',

                },
                amount: 0,
                render: 0,
                loading: false,
                isSendOtp: false,
                userDetails: {
                    netProfit: 0,
                    bankAccountNoOne: '',
                    bankAccountNoTwo: '',
                    paymentOptionIdOne: '',
                    paymentOptionIdTwo: '',
                    paymentOptionIdOneName: '',
                    paymentOptionIdTwoName: '',
                    paymentOptionIdOneActive: false,
                    paymentOptionIdTwoActive: false,
                },
                isProfileApproved: false,
                isWeekend: '',
            }
        },
        validations: {
            transfer: {
                amount: {
                    required: required
                },
                bankId: {
                    required: required
                },
                bankAccountNo: {
                    required: required
                }
            }
        },
        methods: {

            SelectBank: function (data, isOne) {
                this.transfer.bankAccountNo = isOne ? data.bankAccountNoOne : data.bankAccountNoTwo;
                this.transfer.bankName = isOne ? data.paymentOptionIdOneName : data.paymentOptionIdTwoName;

                if (this.transfer.bankName == 'USDT TRC20') {
                    this.transfer.feeAmount = this.transfer.amount == 0 ? 0 : this.transfer.amount * 5 / 100;
                }
                else {
                    this.transfer.feeAmount = this.transfer.amount == 0 ? 0 : this.transfer.amount * 10 / 100;
                }
            },

            updateFee: function (value) {
                this.transfer.amount = Math.round(value);

                if (this.transfer.bankName == 'USDT TRC20') {
                    this.transfer.feeAmount = this.transfer.amount == 0 ? 0 : this.transfer.amount * 5 / 100;
                }
                else {
                    this.transfer.feeAmount = this.transfer.amount == 0 ? 0 : this.transfer.amount * 10 / 100;
                }

            },

            SendOtp: function () {
                var root = this;
                this.loading = true;
                this.isSendOtp = true;

                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.get('/account/SendOtpVerification', { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        console.log(response.data)
                        if (response.data) {
                            root.loading = false;
                            root.$swal({
                                title: 'OTP!',
                                text: 'OTP send to your email',
                                type: 'success',
                                icon: 'success',
                                confirmButtonClass: "btn btn-success",
                                buttonsStyling: false
                            });
                        }
                        else {
                            root.$swal({
                                title: 'Error!',
                                text: "Something Went Wrong",
                                type: 'error',
                                icon: 'error',
                                confirmButtonClass: "btn btn-info",
                                buttonsStyling: false
                            });
                            root.loading = false;
                        }
                    }).catch(error => {
                        console.log(error)
                        root.$swal.fire(
                            {
                                icon: 'error',
                                type: 'error',
                                title: 'Error',
                                text: "Something Went Wrong",
                                showConfirmButton: false,
                                timer: 5000,
                                timerProgressBar: true,
                            });

                        root.loading = false;
                    })
                    .finally(() => root.loading = false);
            },

            SaveFund: function () {
                var root = this;
                this.loading = true;

                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.post('/Bonus/SaveWithdrawal', this.transfer, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        console.log(response.data)
                        if (response.data.id != '00000000-0000-0000-0000-000000000000' && response.data.isSuccess) {
                            root.loading = false;
                            root.$swal({
                                title: 'Request!',
                                text: response.data.isAddUpdate,
                                type: 'success',
                                icon: 'success',
                                confirmButtonClass: "btn btn-success",
                                buttonsStyling: false
                            }).then(function (result) {
                                if (result) {
                                    window.location.href = '/Dashboard';
                                }
                            });
                        }
                        else {
                            root.$swal({
                                title: 'Error!',
                                text: response.data.isAddUpdate,
                                type: 'error',
                                icon: 'error',
                                confirmButtonClass: "btn btn-info",
                                buttonsStyling: false
                            });
                            root.loading = false;
                        }
                    }).catch(error => {
                        console.log(error)
                        root.$swal.fire(
                            {
                                icon: 'error',
                                type: 'error',
                                title: 'Error',
                                text: "Something Went Wrong",
                                showConfirmButton: false,
                                timer: 5000,
                                timerProgressBar: true,
                            });

                        root.loading = false;
                    })
                    .finally(() => root.loading = false);
            },

            SaveEdit: function () {
                var root = this;
                this.loading = true;

                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.post('/Bonus/UpdateStatusWithdrawal', this.transfer, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        console.log(response.data)
                        if (response.data.id != '00000000-0000-0000-0000-000000000000' && response.data.isSuccess) {
                            root.loading = false;
                            root.$swal({
                                title: 'Request!',
                                text: response.data.isAddUpdate,
                                type: 'success',
                                icon: 'success',
                                confirmButtonClass: "btn btn-success",
                                buttonsStyling: false
                            }).then(function (result) {
                                if (result) {
                                    root.close();
                                }
                            });
                        }
                        else {
                            root.$swal({
                                title: 'Error!',
                                text: response.data.isAddUpdate,
                                type: 'error',
                                icon: 'error',
                                confirmButtonClass: "btn btn-info",
                                buttonsStyling: false
                            });
                            root.loading = false;
                        }
                    }).catch(error => {
                        console.log(error)
                        root.$swal.fire(
                            {
                                icon: 'error',
                                type: 'error',
                                title: 'Error',
                                text: "Something Went Wrong",
                                showConfirmButton: false,
                                timer: 5000,
                                timerProgressBar: true,
                            });

                        root.loading = false;
                    })
                    .finally(() => root.loading = false);
            },


            close: function () {
                this.$emit('close');
            }
        },

        created: function () {

            this.isProfileApproved = localStorage.getItem('Verified') == 'true' ? true : false;
            this.isWeekend = moment().format('dddd');


            if (this.type == 'Add') {
                this.userDetails = this.userDetail;
                this.render++;
            }
            else {
                this.transfer.id = this.userDetail.id;
                this.transfer.amount = this.userDetail.amount;
                this.transfer.feeAmount = this.userDetail.feeAmount;
                this.transfer.bankId = this.userDetail.bankId;
                this.transfer.bankAccountNo = this.userDetail.bankAccountNo;
                this.transfer.approval = this.approval;
            }


        },
        mounted: function () {

        },

    }
</script>